import { CONSENT_CATEGORIES } from './categories';

export const CONSENT_INTEGRATION_MAP = {
    googleTagManager: CONSENT_CATEGORIES.ANALYTICS,
    googleAnalytics: CONSENT_CATEGORIES.ANALYTICS,
    hotjar: CONSENT_CATEGORIES.ANALYTICS,
    registrationTracking: CONSENT_CATEGORIES.ANALYTICS,
    socialAuthTracking: CONSENT_CATEGORIES.ANALYTICS,
    providerPurchaseTracking: CONSENT_CATEGORIES.ANALYTICS,
    openaiAdsPixel: CONSENT_CATEGORIES.MARKETING,
    googleAuthScript: CONSENT_CATEGORIES.FUNCTIONAL,
    googleOneTap: CONSENT_CATEGORIES.FUNCTIONAL,
    recaptcha: CONSENT_CATEGORIES.NECESSARY
};

export function getIntegrationCategory(integrationName) {
    return CONSENT_INTEGRATION_MAP[integrationName] || CONSENT_CATEGORIES.NECESSARY;
}